import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Validators, FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { GetRegisterUserStartAction, GetOtp, RegisterLinkValidate, Logout, ClearAction } from '../store/auth.actions';
import { MatSelectChange, MatCheckboxChange, MatDialog } from '@angular/material';
import { API } from '../../services/Api.service'
import { RegistrationSuccesful } from 'src/app/dialogs/registation-successful/registration-successful';
import { VerifyOtpComponent } from './verify-otp/verify-otp.component'
import { NotificationsService } from 'angular2-notifications';
import { GetConfigurations } from 'src/app/features/home/configurations/store/configurations.actions';
import { takeUntil, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { LoaderShow } from 'src/app/features/loader/store/loader.actions';
import { ValidationUtil, VALIDATION_MESSAGES } from '../../utils/validation.util';
import { NotificationModalComponent } from "../../features/common-components/notification-modal/notification-modal.component";
import { LogoutDialogComponent } from 'src/app/dialogs/logout-dialog/logout-dialog.component';


@Component({
    selector: 'app-registration-screen',
    templateUrl: './registration-screen.component.html',
    styleUrls: ['./registration-screen.component.scss']
})
export class RegistrationScreenComponent implements OnInit, OnDestroy {

    jwtToken: any;
    registerForm: FormGroup
    confirmpwd = "";
    setPassword = "";
    registerAction = true;
    mismatchtext = "";
    role;
    selectedCountryCode: string;
    countryCodes;
    file;
    profilePicName;
    registrationSuccessFull: Boolean = false;
    otpVerified: boolean = false;
    formData: FormData = new FormData();
    verifiedPhoneNumber: any;
    acquiredLength: number = 0;
    stopper$: Subject<any> = new Subject();
    decodedToken: any = {};
    wrongPasswordFormat: boolean = false;
    configObj: any = {};
    specialCharregex: RegExp;
    numCount: RegExp;
    passwordEntered: string = '';
    numRegex: RegExp;
    upperCaseregex: RegExp;
    validationMsg = VALIDATION_MESSAGES;
    passwordValidationMsg: string = 'Password must contain a minimum of 7 characters; a maximum of 15 characters; at least one special character (*, /, @, #, etc.); at least one uppercase character and at least two digits';
    accessToken;
    userId;
    userDetail;
    showPassword: boolean = false;
    showConfirmPassword: boolean = false;
    phoneNumber: any

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        public fb: FormBuilder,
        private _store: Store<AppState>,
        private api: API,
        public dialog: MatDialog,
        private notificationService: NotificationsService,
    ) {
        this.registerForm = this.fb.group({
            firstName: ["", Validators.compose([
                Validators.required,
                ValidationUtil.cannotBeBlank,
            ])],
            middleName: [""],
            lastName: ["", Validators.compose([
                Validators.required,
                ValidationUtil.cannotBeBlank,
            ])],
            email: [],
            // upload:[""],
            contact: ["", Validators.compose([
                Validators.required,
                Validators.minLength(5),
            ])],
            aboutMe: ["", Validators.maxLength(200)],
            password: ["", Validators.compose([
                Validators.required,
            ])],
            upfile: [],
            confirmpwd: ["",
                Validators.compose([
                    Validators.required,
                ]),
            ],
            countryCode: ['', Validators.required],
            profilePic: ['']
        },
            {
                validator: MustMatch('password', 'confirmpwd'),
            });
        this.api.getCountryCodes().subscribe(response => {
            this.countryCodes = response;
        });

        _store.select(state => state.auth).subscribe(auth => {
            this.accessToken = auth.accessToken;
            const userDetails = (auth.user || {}).details;
            this.userId = (userDetails || {})._id;
            this.userDetail = userDetails;

        });

        if (this.accessToken) {
            //this._store.dispatch(new Logout(this.userId));
            const logoutUserDialog = this.dialog.open(LogoutDialogComponent, {
                hasBackdrop: true,
                width: '700px',
                panelClass: 'cmp-modal',
                data: {
                    userDetail: this.userDetail,
                    token: this.accessToken
                }
            });
            logoutUserDialog.afterClosed().subscribe((response) => {
            });
        }
    }

    ngOnInit() {

        this.activatedRoute.params.subscribe((params: any) => {
            this.jwtToken = params.token;
            this.decodeJWTToken();
        });

        this._store.dispatch(new RegisterLinkValidate(this.jwtToken));

        this.registerForm.controls['countryCode'].setValue('+91')
        this._store.dispatch(new GetConfigurations());
        this._store.select(state => state.configurations.configurations).pipe(takeUntil(this.stopper$)).subscribe((resp: any) => {
            if (Object.keys(resp).length) {
                console.log("here", resp);
                this.configObj = resp;
                this.acquiredLength = resp['aboutMe'].value;
                const passwordMinLength = +resp['passwordMinLength'].value;
                const passwordMaxLength = +resp['passwordMaxLength'].value;
                this.registerForm.get('password').setValidators([
                    Validators.required,
                    Validators.minLength(passwordMinLength),
                    Validators.maxLength(passwordMaxLength),
                ])

                this.passwordValidationMsg = `Password must contain a minimum of ${passwordMinLength} characters; a
                maximum of ${passwordMaxLength} characters`

                if (resp['specialCharCount'].value != 0) {
                    this.passwordValidationMsg += `; at least ${+resp['specialCharCount'].value} special character(s) (*, /, @, #, etc.)`
                }
                if (resp['upperCaseCount'].value != 0) {
                    this.passwordValidationMsg += `; at least ${+resp['upperCaseCount'].value} uppercase character(s)`
                }
                if (resp['numCount'].value != 0) {
                    this.passwordValidationMsg += ` and at least ${+resp['numCount'].value} digit(s)`
                }
            }
        })
        this.registerForm.get('password').valueChanges.subscribe((password) => {
            let upperCaseCount = parseInt(this.configObj['upperCaseCount'].value);
            let specialCharCount = parseInt(this.configObj['specialCharCount'].value);
            let passwordMaxLength = parseInt(this.configObj['passwordMaxLength'].value);
            let passwordMinLength = parseInt(this.configObj['passwordMinLength'].value);
            let numCount = parseInt(this.configObj['numCount'].value);
            this.passwordEntered = password;

            this.numRegex = new RegExp(`((.*[0-9]){${numCount},}.*)`);
            this.upperCaseregex = new RegExp(`((.*[A-Z]{${upperCaseCount},}.*))`)
            // this.specialCharregex = new RegExp(`(.*[@#$%]){${specialCharCount},}.*`)
            this.specialCharregex = new RegExp(`(.*[^A-Za-z0-9]){${specialCharCount},}.*`)
            if (password.length >= passwordMinLength && password.length <= passwordMaxLength) {
                if (this.numRegex.test(password)) {
                    //console.log(upperCaseCount, "upper", specialCharCount, "specialCount", passwordMaxLength, "password length", numCount, "numberCunt");
                    this.wrongPasswordFormat = false;
                    if (this.upperCaseregex.test(password)) {
                        this.wrongPasswordFormat = false;
                        if (this.specialCharregex.test(password)) {
                            this.wrongPasswordFormat = false;
                        } else {
                            this.wrongPasswordFormat = true;
                        }
                    } else {
                        this.wrongPasswordFormat = true;
                    }
                } else {
                    this.wrongPasswordFormat = true;
                }
            } else {
                this.wrongPasswordFormat = true;
            }
        })

        this.registerForm.get('countryCode').valueChanges.subscribe(val => {
            if (this.selectedCountryCode == val && this.verifiedPhoneNumber == val + this.registerForm.value['contact'])
                this.otpVerified = true
            else
                this.otpVerified = false
        });

        this.registerForm.get('contact').valueChanges.pipe(debounceTime(2000),
            distinctUntilChanged()).subscribe(val => {
                if (this.phoneNumber == val && this.verifiedPhoneNumber == this.registerForm.value['countryCode'] + val)
                    this.otpVerified = true
                else
                    this.otpVerified = false
            });
    }

    isInputNumber(event) {
        const ch = String.fromCharCode(event.which);
        if (!(/[0-9]/.test(ch))) {
            event.preventDefault();
        }
    }

    register() {
        if (this.registerForm.invalid || this.wrongPasswordFormat) {
            return false;
        }
        // Condition added to prevent the user from registering before otp verification
        if (!this.otpVerified) {
            return this.notificationService.error("Please verify your phone number");
        }

        let formData = new FormData();
        formData.append('upfile', this.file);
        if ((this.registerForm.value.password.trim() === this.registerForm.value.confirmpwd.trim()) && (this.registerForm.valid)) {
            formData.append('firstName', this.registerForm.value.firstName.trim());
            formData.append('middleName', this.registerForm.value.middleName.trim());
            formData.append('lastName', this.registerForm.value.lastName.trim());
            formData.append('countryCode', this.registerForm.value.countryCode);
            formData.append('phone', this.registerForm.value.contact);
            formData.append('aboutme', this.registerForm.value.aboutMe.trim());
            formData.append('password', this.registerForm.value.password);

            this._store.dispatch(new LoaderShow());
            this._store.dispatch(new ClearAction());
            this._store.dispatch(new GetRegisterUserStartAction(this.jwtToken, formData));

            this._store.select(state => state.auth.registrationSuccess)
                .pipe(takeUntil(this.stopper$))
                .subscribe((resp: any) => {
                    if (Object.keys(resp).length) {
                        const registrationSuccessDialog = this.dialog.open(RegistrationSuccesful, {
                            hasBackdrop: true,
                            width: '700px',
                            panelClass: 'cmp-modal',
                        });
                        registrationSuccessDialog.afterClosed().subscribe((response) => {
                        });
                    }
                });
        }
    }

    // onKeydown(event: KeyboardEvent) {
    //     let x = event.keyCode;
    //     if (x == 32) {
    //         return false;
    //     } else {
    //         if ((this.registerForm.value.password === this.registerForm.value.confirmpwd) && (this.registerForm.valid)) {
    //             this.registerAction = false;
    //             this.mismatchtext = "";
    //         } else if (this.registerForm.value.confirmpwd.length > this.registerForm.value.password.length) {
    //             this.mismatchtext = "Password Mismatch";
    //         } else if (this.registerForm.value.confirmpwd.length == this.registerForm.value.password.length) {
    //             if (this.registerForm.value.password !== this.registerForm.value.confirmpwd) {
    //                 this.mismatchtext = "Password Mismatch";
    //             }
    //         }
    //     }
    // }

    restrictSpace(event: KeyboardEvent) {
        let x = event.keyCode;
        if (x == 32) {
            return false;
        }
    }

    decodeJWTToken() {
        try {
            const decoded = JSON.parse(atob(this.jwtToken.split('.')[1]));
            this.registerForm.controls['email'].setValue(decoded.email);
            // this.registerForm.controls['fullName'].setValue(decoded.firstName + " " + decoded.secondName);
            this.decodedToken = decoded
            this.role = decoded.role;
        } catch (e) {

        }
    }

    handleFileInput(event) {
        if (event.target.files.length > 0) {
            this.file = event.target.files[0];
            this.profilePicName = this.file.name;
        }
    }

    okClicked() { }

    /* 
        @author Pooja Gawas
        Opens a dialog for user to enter OTP to verify mobile number
        @param {countryCode} string
        @param {contact} string phone number
    */
    openVerifyOtpDialog(countryCode, contact) {
        this._store.dispatch(new GetOtp(this.decodedToken.id || '', { phone: countryCode + contact }));

        const dialogRef = this.dialog.open(VerifyOtpComponent, {
            hasBackdrop: true,
            width: '700px',
            panelClass: 'task-detail-modal',
            data: {
                phoneNumber: contact,
                countryCode: countryCode,
                decodedToken: this.decodedToken
            }
        });

        dialogRef.afterClosed().subscribe((response) => {
            if (Object.keys(response).length) {
                this.phoneNumber = contact
                this.selectedCountryCode = countryCode
                this.verifiedPhoneNumber = countryCode + contact;
                this.otpVerified = true;
            } else {
                this.otpVerified = false;
            }
        })
    }

    /* 
        @author Pooja Gawas
        Enables verify otp button if  user changes mobile number again after successful otp verification
    */
    enableVerifyOtp() {
        if (this.verifiedPhoneNumber) {
            if (this.verifiedPhoneNumber != this.registerForm.value.countryCode + this.registerForm.value.contact) {
                if (this.otpVerified) {
                    this.otpVerified = false;
                }
            } else {
                this.otpVerified = true;
            }
        }
    }

    showPasswordFunction(type) {
        switch (type) {
            case 'new':
                this.showPassword = !this.showPassword;
                break;
            case 'confirm':
                this.showConfirmPassword = !this.showConfirmPassword;
                break;
            default:
                break;
        }
    }

    ngOnDestroy() {
        this.stopper$.next();
        this.stopper$.complete();
    }

}

export function MustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];

        if (matchingControl.errors && !matchingControl.errors.mustMatch) {
            // return if another validator has already found an error on the matchingControl
            return;
        }

        // set error on matchingControl if validation fails
        if (control.value !== matchingControl.value) {
            matchingControl.setErrors({ mustMatch: true });
        } else {
            matchingControl.setErrors(null);
        }
    }
}
